import { render, staticRenderFns } from "./Mailling.vue?vue&type=template&id=7c5d599f&scoped=true&lang=pug&"
import script from "./Mailling.vue?vue&type=script&lang=js&"
export * from "./Mailling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d599f",
  null
  
)

export default component.exports